<template>
  <v-container fluid>
    <v-card>
      <v-toolbar dense style="background:#F5F5F5">
        <v-toolbar-title dense style="color:#607D8B;font-weight:bold">Permissions des agents
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn @click="refresh" icon>
          <v-icon color="#009688" large>mdi-refresh</v-icon>
          <template v-slot:loader>
            <span class="custom-loader"> <v-icon light>cached</v-icon></span>
          </template>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-dialog fullscreen v-model="loading">
          <v-container fill-height fluid style="background-color: rgba(200, 200, 200, 0.5);">
            <v-layout align-center="true" justify-center="true">
              <v-progress-circular
                  :on-cancel="onCancel"
                  :size="70"
                  color="#009688"
                  indeterminate>
              </v-progress-circular>
            </v-layout>
          </v-container>
        </v-dialog>
        <v-alert :color=AlertColor(type)
                 :dismissible=true
                 :value=true
                 @input="dismissible_close"
                 border="top"
                 class="pre-formatted multi-line"
                 colored-border
                 elevation="2"
                 icon="check_circle"
                 style="color: #546E7A"
                 v-if="type">
          {{ text }}
        </v-alert>
        <v-alert border="top" class="my-4" color="#F44336" dark dense v-if="errors.length>0"
                 v-model="alert">
          <h4 class="mt-2">{{ errors.length }}{{ " Erreur" | pluralize(errors.length) }}
            sur {{ excelData.length }} {{ "enregistrement"|pluralize(excelData.length) }}.
            Merci de corriger et de ne réimporter que les enregistrements ci-dessous rejetés, pour éviter
            tout doublon
          </h4>
          <v-row align="center">
            <v-col class="grow">
              <div :key="index" v-for="(error,index) in errors">
                <h5>
                  <v-icon>mdi-alert-circle</v-icon>
                  {{ "Matricule (" + error.datas.userId + ") -> " + error.message }}
                </h5>
              </div>
            </v-col>
            <v-col class="shrink">
              <v-btn :elevation="1" @click="closeAlert" fab small
                     style="position:absolute;top:18px;right:12px">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-alert>
        <v-card class="mt-1" flat
                tile>
          <v-row>
            <v-col v-if="isMobile===false">
              <v-spacer></v-spacer>
            </v-col>
            <v-col v-if="isMobile===false">
              <v-spacer></v-spacer>
            </v-col>
            <v-col>
              <v-text-field :disabled="disableMainBtn"
                            :id="dynamicID()"
                            @change="search"
                            @keyup.native.enter="search"
                            @click:clear="cleared()"
                            append-icon="mdi-magnify"
                            class="centered-input align-center"
                            clearable
                            hide-details
                            placeholder="Recherche"
                            v-model="searchName">
              </v-text-field>
            </v-col>
            <v-col v-if="isMobile===false">
              <v-spacer></v-spacer>
            </v-col>
            <v-col v-if="isMobile===false">
              <v-spacer></v-spacer>
            </v-col>
            <v-col>
              <v-dialog max-width="600px" persistent v-model="dialog">
                <template @mouseleave.native="hover = false" @mouseover.native="hover = true"
                          v-slot:activator="{ on }">
                  <v-btn :disabled="disableMainBtn" block class="custom-btn white--text" color="#009688"
                         height="45px"
                         large v-on="on">
                    <v-icon class="mr-1">mdi-plus-circle-outline</v-icon>
                    <span>Création profil</span>
                  </v-btn>
                </template>
                <v-card>
                  <v-toolbar
                      color="#01579B"
                      dark
                      flat>
                    <v-spacer></v-spacer>
                    <v-btn
                        @click="close"
                        dark
                        fab
                        small>
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-tabs :grow=true background-color="#01579B" color="#f5f5f5" dark="" right
                          v-model="tab">
                    <v-tabs-slider></v-tabs-slider>
                    <v-tab href="#tab-1"> Via un formulaire</v-tab>
                  </v-tabs>
                  <v-tabs-items v-model="tab">
                    <v-tab-item value="tab-1">
                      <v-card-text>
                        <v-container>
                          <v-row class="justify-center align-center">
                            <v-col cols="12" md="6" sm="6">
                              <v-text-field :id="dynamicID()"
                                            class="centered-input align-center"
                                            color="#01579B"
                                            label="Matricule"
                                            prepend-inner-icon="mdi-human-male"
                                            v-model="editedItem.userId">
                              </v-text-field>
                            </v-col>
                          </v-row>
                          <v-row class="justify-center align-center">
                            <v-col cols="12" md="6" sm="6">
                              <v-select :items="PermissionsGroup"
                                        @change="loadPermissionsGroup"
                                        class="centered-input align-center text-center"
                                        color="#01579B"
                                        item-text="type"
                                        item-value="type"
                                        label="Nom profil de groupe"
                                        prepend-inner-icon="mdi-account-group-outline"
                                        v-model="editedItem.groupName">
                                <template v-slot:selection="{ item }">
                                                                  <span class="d-flex justify-center"
                                                                        style="width: 100%;">
                                                                    {{ item }}
                                                                  </span>
                                </template>
                              </v-select>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn :disabled="!FormIsValid && !loading" @click="creer"
                               class="white--text"
                               color="#01579B" depressed>Créer permissions
                        </v-btn>
                      </v-card-actions>
                    </v-tab-item>
                  </v-tabs-items>
                </v-card>
              </v-dialog>
            </v-col>
          </v-row>
        </v-card>
        <v-card class="mt-4"
                elevation="6">
          <hot-table :settings="hotSettings" ref="hotTable"></hot-table>
        </v-card>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import {HotTable} from "@handsontable/vue";
import "handsontable/languages/fr-FR";
import apiClient from "../../../config/api.js";
import moment from "moment"
import "vue-loading-overlay/dist/vue-loading.css";
import Handsontable from "handsontable";

function customDropDownRender(instance, td, row, col, prop, value, cellProperties) {
  Handsontable.renderers.AutocompleteRenderer.apply(this, arguments);
  cellProperties.data = 'options';
  cellProperties.type = 'dropdown';

  if (col === 4) {
    cellProperties.source = JSON.parse(sessionStorage.getItem("PermissionsGroup"));
  }
}

function isMobileDevice() {
  return /Mobi|Android/i.test(navigator.userAgent);
}

export default {
  name: "permissions_agent",
  components: {HotTable},
  data: function () {
    return {
      isMobile: isMobileDevice(),
      disableMainBtn: false,
      searchName: "",
      PermissionsGroup: [],
      dialogTmp: false,
      files: [],
      lastHighlitedRow: null,
      type: null,
      elapse: null,
      loading: false,
      loading2: false,
      menustartWorkingDate: false,
      toObject: [],
      editedItem: {
        id: "",
        userId: "",
        groupName: ""
      },
      show1: false,
      e6: 1,
      tab: null,
      dialog: false,
      alert: false,
      fullPage: false,
      text: "",
      color: "",
      file: "",
      editedIndex: -1,
      errors: [],
      excelData: [],
      genre: ["Homme", "Femme"],
      arrayAbs: [],
      hotSettings: {
        renderAllRows: false,          // Rendu virtuel
        viewportRowRenderingOffset: 'auto',  // Calcul dynamique
        data: [],
        colWidths: 100,
        width: "100%",
        height: "675px",
        fixedRowsTop: 0,
        columnSorting: true,
        sortIndicator: true,
        filters: true,
        selectionMode: "single",
        dropdownMenu: ["filter_by_condition", "filter_action_bar", "filter_operators", "filter_by_value"],
        licenseKey: "non-commercial-and-evaluation",
        stretchH: "all",
        minSpareRows: false,
        contextMenu: ["remove_row"],
        language: "fr-FR",
        customBorders: true,
        columnHeaders: true,
        rowHeaders: true,
        stretch: "all",
        readOnly: false,
        afterChange: this.afterChangeMe,
        beforeRemoveRow: this.beforeRemoveRowMe,
        afterFilter: this.afterFilter,
        afterLoadData: this.afterLoadData,
        currentRowClassName: 'rowHighlight',
        manualColumnResize: true,
        className: "htCenter htMiddle",
        hiddenColumns: {
          columns: [0],
          indicators: false
        },
        colHeaders: [
          "Id", "Matricule", "Nom", "Prénom", "Nom profil groupe", "Date création"
        ],
        columns: [
          {title: "Id", width: "80px", readOnly: true},
          {title: "Matricule", width: "150px"},
          {title: "Nom", width: "160px", readOnly: true},
          {title: "Prénom", width: "200px", readOnly: true},
          {
            title: "Nom profil groupe",
            width: "200px",
            type: 'dropdown',
            renderer: customDropDownRender,
            allowInvalid: false,
            strict: true
          },
          {
            title: "Date création",
            width: "180px",
            dateFormat: "DD-MM-YYYY HH:mm:ss",
            correctFormat: true,
            type: "date",
            readOnly: true
          },
        ]
      }
    }
  },
  created() {
    this.getData()
    this.loadPermissionsGroup()
  },

  computed: {
    FormIsValid() {
      return (
          this.editedItem.userId !== "" &&
          this.editedItem.groupName !== ""
      );
    },
    userRole() {
      return this.$store.getters.user.role;
    },
  },
  methods: {
    cleared() {
      this.searchName = "";
      this.getData();
    },
    search() {
      var query = this.isEmpty(this.searchName) ? this.searchName : this.searchName.toLowerCase()

      if (this.isEmpty(query)) {
        this.cleared()
      }

      var row;
      var col;
      var rLen;
      var cLen;
      var data = this.$refs.hotTable.hotInstance.getData();
      var array = [];
      for (row = 0, rLen = data.length; row < rLen; row++) {
        for (col = 1, cLen = Object.keys(data[row]).length; col < cLen; col++) {
          var x = Object.keys(data[row])[col];
          if (('' + data[row][x]).toLowerCase().indexOf(query) > -1) {
            array.push(data[row]);
            break;
          }
        }
      }
      this.$refs.hotTable.hotInstance.loadData(array);
    },
    dynamicID() {
      return 'dynamicID-' + Math.floor(Math.random() * Date.now().toString());
    },
    loadPermissionsGroup() {
      apiClient
          .get(
              `${this.$store.getters.user.baseUrl}/account/profilsgroup/` + sessionStorage.getItem("userId")
          )
          .then(response => {
            sessionStorage.setItem("PermissionsGroup", null)
            this.PermissionsGroup = []
            let datas = response.data.datas;
            datas.forEach(item => {
              this.PermissionsGroup.push(item.groupName);
            });
            sessionStorage.setItem("PermissionsGroup", JSON.stringify(this.PermissionsGroup))
          })
          .catch(() => {
          });
    },
    afterSelectionEnd(r, c) {
      var i;
      if (this.lastHighlitedRow !== null) {
        for (i = 0; i < this.$refs.hotTable.hotInstance.countCols(); i++) {
          this.$refs.hotTable.hotInstance.setCellMeta(this.lastHighlitedRow, i, 'className', 'htCenter htMiddle');
        }
      }

      for (i = 0; i < this.$refs.hotTable.hotInstance.countCols(); i++) {
        this.$refs.hotTable.hotInstance.setCellMeta(r, i, 'className', 'area highlight, htCenter htMiddle');
      }
      this.lastHighlitedRow = r;

      this.$refs.hotTable.hotInstance.render()
    },
    formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    isEmpty(str) {
      return (!str || 0 === str.length || /^\s*$/.test(str));
    },
    getData() {
      this.loading = true

      String.prototype.capitalize = function (allWords) {
        return (allWords) ? // if all words
            this.split(' ').map(word => word.capitalize()).join(' ') : //break down phrase to words then  recursive calls until capitalizing all words
            this.charAt(0).toUpperCase() + this.slice(1); // if allWords is undefined , capitalize only the first word , mean the first char of the whole string
      }

      apiClient
          .get(
              `${this.$store.getters.user.baseUrl}/account/profilsagent/` + sessionStorage.getItem("userId")
          )
          .then(response => {
            this.loading = false
            let tabArray = []
            let newObj = response.data.datas;

            if (response.data.status !== 200) {
              this.color = "#009688"
              this.text = response.data.message;
              this.showAlert('warning')
              this.disableMainBtn = true
            } else {
              this.disableMainBtn = false
            }

            newObj.forEach((item) => {
              tabArray.push([
                item["id"],
                item["userId"],
                this.isEmpty(item["lastName"]) ? "" : item["lastName"].toUpperCase(),
                this.isEmpty(item["firstName"]) ? "" : item["firstName"].toLowerCase().capitalize(true),
                item["groupName"],
                this.datefull(item["creationDate"])
              ])
            })

            this.$refs.hotTable.hotInstance.loadData(tabArray)
            this.toObject = [this.hotSettings.colHeaders, ...this.$refs.hotTable.hotInstance.getData()]
          })
          .catch(() => {
            this.loading = false
          });
    },
    onCancel() {
      this.loading = false
    },
    refresh() {
      this.getData()
    },
    datefull(val) {
      if (!val) {
        return
      }
      const date = new Date(val);
      return moment(date).format("DD-MM-YYYY HH:mm:ss");
    },
    convertDate(val) {
      const date = new Date(val);
      return moment(date).format("DD-MM-YYYY");
    },
    close() {
      this.initEditedItem();
      this.dialog = false;
      this.file = "";
      this.files = [];
      this.fileBtn = true;
      this.drag_over = false;
    },
    AlertColor(type) {
      return type === "info" ? "#4CAF50" : "#F44336";
    },
    showAlert(type) {
      this.type = type

      let timer = this.showAlert.timer
      if (timer) {
        clearTimeout(timer)
      }
      this.showAlert.timer = setTimeout(() => {
        this.type = null
      }, 20000)

      this.elapse = 1
      let t = this.showAlert.t
      if (t) {
        clearInterval(t)
      }

      this.showAlert.t = setInterval(() => {
        if (this.elapse === 3) {
          this.elapse = 0
          clearInterval(this.showAlert.t)
        } else {
          this.elapse++
        }
      }, 5000)
    },
    dismissible_close() {
      this.elapse = 3
      clearTimeout(this.showAlert.timer)
      clearInterval(this.showAlert.t)
      this.type = null
    },
    closeAlert() {
      this.alert = false
      this.text = ""
      this.errors = []
    },
    onPickFile() {
      this.$refs.fileInput.click();
    },
    afterLoadData() {
      this.toObject = [this.hotSettings.colHeaders, ...this.$refs.hotTable.hotInstance.getData()]
    },
    afterFilter() {
      this.toObject = [this.hotSettings.colHeaders, ...this.$refs.hotTable.hotInstance.getData()]
    },
    afterChangeMe(changes, source) {
      if (changes !== null && source === "edit" && (changes[0][2] !== changes[0][3])) {
        let message = {
          title: 'Fenêtre de confirmation',
          body: 'Confirmez la modification de la permission de l\'agent.'
        };

        this.$dialog
            .confirm(message)
            .then(dialog => {
              this.initEditedItem();
              this.loading = true
              let obj = {}
              let newObj = {}

              obj = this.$refs.hotTable.hotInstance.getData()[changes[0][0]]

              newObj = {
                "id": obj[0],
                "userId": obj[1],
                "groupName": obj[4],
                "revisedUser": sessionStorage.getItem("userId")
              }

              apiClient
                  .post(
                      `${this.$store.getters.user.baseUrl}/account/profilagent/` + sessionStorage.getItem("userId"),
                      newObj
                  )
                  .then(res => {
                    dialog.close();
                    this.loading = false
                    if (res.data.status === 200) {
                      this.color = "#009688"
                      this.text = res.data.message;
                      this.showAlert('info')
                      this.getData()
                    } else {
                      this.alert = true
                      this.color = "#F44336"
                      this.alert = true
                      this.text = res.data.message;
                      this.dialog = false;

                      let myData = this.$refs.hotTable.hotInstance.getData()
                      myData[changes[0][0]][changes[0][1]] = changes[0][2]
                      this.$refs.hotTable.hotInstance.loadData(myData)
                      this.showAlert('warning')
                    }
                  })
                  .catch((err) => {
                    dialog.close();
                    let myData = this.$refs.hotTable.hotInstance.getData()
                    myData[changes[0][0]][changes[0][1]] = changes[0][2]
                    this.$refs.hotTable.hotInstance.loadData(myData)

                    this.alert = true
                    this.color = "#F44336"
                    this.text = err.data.message;
                    this.loading = false
                    this.showAlert('warning')
                  });
            })
            .catch(() => {
              let myData = this.$refs.hotTable.hotInstance.getData()
              myData[changes[0][0]][changes[0][1]] = changes[0][2]
              this.$refs.hotTable.hotInstance.loadData(myData)
            });
      }
    },
    beforeRemoveRowMe(index, amount) {
      let rowId = this.$refs.hotTable.hotInstance.getData()[index]
      let message = {
        title: 'Fenêtre de confirmation',
        body: 'Confirmez la suppression de la permission de l\'agent.'
      };

      this.$dialog
          .confirm(message)
          .then(dialog => {
            this.loading = true

            apiClient
                .delete(
                    `${this.$store.getters.user.baseUrl}/account/profilagent/` + rowId[0] + "/" + sessionStorage.getItem("userId")
                )
                .then(res => {
                  dialog.close();
                  this.loading = false
                  if (res.data.status === 200) {
                    this.color = "#009688"
                    this.text = res.data.message;
                    this.showAlert('info')
                  } else {
                    this.$refs.hotTable.hotInstance.alter("insert_row_above", index)

                    this.$refs.hotTable.hotInstance.setCellMeta(index, 0, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 2, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 3, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 5, "readOnly", false);

                    this.$refs.hotTable.hotInstance.populateFromArray(index, 0, [rowId]);

                    this.$refs.hotTable.hotInstance.setCellMeta(index, 0, "readOnly", true);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 2, "readOnly", true);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 3, "readOnly", true);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 5, "readOnly", true);

                    this.color = "#F44336"
                    this.alert = true
                    this.text = res.data.message;
                    this.dialog = false;
                    this.showAlert('warning')
                  }
                })
                .catch((error) => {
                  dialog.close();
                  this.loading = false
                  this.alert = true
                  this.color = "#F44336"
                  this.text = error;
                  this.showAlert('warning')
                });
          })
          .catch(() => {
            this.$refs.hotTable.hotInstance.alter("insert_row_above", index)

            this.$refs.hotTable.hotInstance.setCellMeta(index, 0, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 2, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 3, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 5, "readOnly", false);

            this.$refs.hotTable.hotInstance.populateFromArray(index, 0, [rowId]);

            this.$refs.hotTable.hotInstance.setCellMeta(index, 0, "readOnly", true);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 2, "readOnly", true);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 3, "readOnly", true);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 5, "readOnly", true);
          });
    },
    initEditedItem() {
      this.editedItem.userId = "";
      this.editedItem.groupName = "";
    },
    creer() {
      this.loading = true
      const dataToSave = {
        userId: this.editedItem.userId,
        groupName: this.editedItem.groupName
      };

      apiClient
          .post(
              `${this.$store.getters.user.baseUrl}/account/profilagent/` + sessionStorage.getItem("userId"),
              dataToSave
          )
          .then(res => {
            this.loading = false
            if (res.data.status === 200) {
              this.color = "#009688"
              this.text = res.data.message;
              this.dialog = false;
              this.getData()
              this.showAlert('info')
              this.initEditedItem()
            } else {
              this.alert = true
              this.color = "#F44336"
              this.alert = true
              this.text = res.data.message;
              this.dialog = false;
              this.showAlert('warning')
            }
          })
          .catch(err => {
            this.alert = true
            this.text = err;
            this.dialog = false;
            this.loading = false
            this.color = "#F44336"
            this.showAlert('warning')
          });
    },
  },
};
</script>

<style scoped>
.toolbar .v-toolbar__content {
  padding: 0 !important
}

.input-class {
  padding: 2px 0;
  border-bottom: solid 1px #999;
  color: #444;
  width: 100%;
}

.v-text-field {
  min-width: 222px;
}

.custom-btn {
  width: 222px;
}

.custom-btn::before {
  color: transparent
}

.custom-btn:hover {
  color: #F5F5F5 !important;
}
</style>